<template>
	<div class="projectDetail">
		<div class="container">
			<div class="title">{{news.title}}</div>
			<div class="info"><span>来源：<span style="padding: 0 20px;">发布时间：{{news.publishDate}}</span></span></div>
			<!--<img class="imgbox" src="../assets/1.jpg" alt="">
			<div class="detail">决定恢复科举时代JFK是地方势力扩大飞机喀什的飞机喀什地方克里斯蒂就</div>-->
			<div style="text-align: center" v-html="news.htmlContent"></div>
		</div>
	</div>
</template>

<script>
    import {getRequest} from '../utils/api'
    export default{
        methods: {
            goBack(){
                this.$router.go(-1);
            }
        },
        mounted: function () {
            let id = this.$route.query.id;
            var _this = this;
            this.loading = true;
			_this.news = {
				title:'新年致辞',
                    newsType:'',
                    state:null,
                    publishDate:'2024-01-01',
                    content:'尊敬的全体员工、合作伙伴们：新春伊始，万象更新。在这个充满希望与挑战的新年之际，我代表公司向大家致以最诚挚的问候和最美好的祝福！过去的一年，我们共同经历了许多挑战和变化，但我们始终保持着坚定的信念和决心，以创新、务实的精神不断前进。我们的团队在各自的岗位上辛勤付出，以卓越的业绩和优质的服务赢得了客户的信任与支持。在此，我代表公司向大家表示衷心的感谢！同时，我也要感谢我们的合作伙伴们。正是有了你们的鼎力支持和默契合作，我们才能够取得更加辉煌的成绩。在新的一年里，我们期待与你们继续携手共进，共同创造更加美好的未来！展望新的一年，我们将继续秉承“客户至上、诚信经营”的理念，不断推陈出新，提升产品和服务的质量。我们将积极拥抱变化，把握机遇，应对挑战，努力实现公司的可持续发展。最后，再次祝愿大家在新的一年里身体健康、工作顺利、家庭幸福！让我们共同期待更加美好的明天！敬祝新年快乐！',
                    htmlContent:'&nbsp&nbsp尊敬的全体员工、合作伙伴们：新春伊始，万象更新。在这个充满希望与挑战的新年之际，我代表公司向大家致以最诚挚的问候和最美好的祝福！<br>过去的一年，我们共同经历了许多挑战和变化，但我们始终保持着坚定的信念和决心，以创新、务实的精神不断前进。我们的团队在各自的岗位上辛勤付出，以卓越的业绩和优质的服务赢得了客户的信任与支持。在此，我代表公司向大家表示衷心的感谢！同时，我也要感谢我们的合作伙伴们。正是有了你们的鼎力支持和默契合作，我们才能够取得更加辉煌的成绩。在新的一年里，我们期待与你们继续携手共进，共同创造更加美好的未来！展望新的一年，我们将继续秉承“客户至上、诚信经营”的理念，不断推陈出新，提升产品和服务的质量。我们将积极拥抱变化，把握机遇，应对挑战，努力实现公司的可持续发展。最后，再次祝愿大家在新的一年里身体健康、工作顺利、家庭幸福！让我们共同期待更加美好的明天！敬祝新年快乐！',
                    summary:'尊敬的全体员工、合作伙伴们：新春伊始，万象更新。',
			};
			_this.loading = false;
        },
        data(){
            return {
                news:{
                    title:'',
                    newsType:'',
                    state:null,
                    publishDate:null,
                    content:'',
                    htmlContent:'',
                    summary:'',
				},
                loading: false,
            }
        }
    }

</script>

<style lang="less">
.projectDetail {
	.container{
		max-width: 1170px;
		margin: 0 auto;
		.title {
			text-align: center;
			padding: 40px 0;
			font-size: 24px;
			line-height: 1.5;
			text-align: center;
			color: #444;
		}
		.info {
			font-size: 14px;
			text-align: center;
			margin-bottom: 30px;
			padding: 6px 10px;
			color: #777;
			border-bottom: 1px solid #ddd;
		}
		.imgbox {
			width: 100%;
			max-height: 500px;
		}
		.detail {
			padding: 20px 0;
		}
	}
}
</style>
